// extracted by mini-css-extract-plugin
export default {"Genres":"Genres_Genres__mOREf","GenresMainDiv":"Genres_GenresMainDiv__DfKJO"};